// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"styles_hamburger__c5AMt","active":"styles_active__VoPC1"};